<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-09-27 13:58:08
 * @LastEditTime: 2020-10-08 16:57:59
 * @Description: 用户配置tabs
-->
<template>
  <div>
    <Button
      type="error"
      @click="deleteCustomerClicked"
      style="margin-right: 12px"
      >删除客户</Button
    >
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      customer: (state) => state.customer.selectCustomer,
    }),
  },
  methods: {
    ...mapActions({
      deleteCustomer: "customer/deleteCustomerAction",
    }),
    deleteCustomerClicked() {
      this.$Modal.confirm({
        title: `删除：${this.customer.name}`,
        content:
          "<p>这个客户将会被删除，并无法恢复，所关联的销售订单、生产订单、运输等记录关联的客户将会显示成空白，请慎重！</p>",
        loading: true,
        onOk: async () => {
          try {
            await this.deleteCustomer({ id: this.customer._id });
            this.$Modal.remove();
            this.$emit("deleSuccess");
          } catch (error) {
            throw error(error);
          }
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped></style>